export default {
      id: "icon--lesson-usage",
      viewBox: "0 0 31 27",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--lesson-usage",
      toString: function () {
        return this.url;
      }
    }